(function () {
    'use strict';

    angular
        .module('app')
        .controller('acsDownloadPage', acsDownloadPage);

    acsDownloadPage.$inject = ['loginService', '$mdDialog', '$localStorage', 'needUpdate', 'acsFilename', 'newViewer'];

    function acsDownloadPage(loginService, $mdDialog, $localStorage, needUpdate, acsFilename, newViewer) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'acsDownloadPage';
        vm.loginService = loginService;
        vm.needUpdate = needUpdate;
        vm.isEdge = bowser.name.toLowerCase() == 'microsoft edge';
        console.log("needUpdate", needUpdate);
        vm.usingNewViewer = newViewer;

        vm.hide = function () {
            $mdDialog.hide();
        }

        vm.remindDownload = $localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt;
        vm.remindDownloadToggle = function () {
            if ($localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt == undefined) {
                $localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt = false;
            }

            $localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt = !$localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt;
        }

        vm.downloadACS = function () {

            downloadURI("../Synergis.WebApi/downloads/" + acsFilename, acsFilename);
            //window.location.assign('../Synergis.WebApi/downloads/ClientServices.msi');
        }

        vm.downloadViewer = function () {
            downloadURI("../Synergis.WebApi/downloads/" + "DocumentViewer.msi", "DocumentViewer.msi");
        }

        vm.downloadRealDWG = function () {
            downloadURI("../Synergis.WebApi/downloads/RealDWG.msi", "RealDWG.msi");
            //window.location.assign('../Synergis.WebApi/downloads/RealDWG.msi');
        }

        vm.launchEdgeUtil = function () {
            window.protocolCheck("adeptclientservices:" + 'edgeutil', function () {
                
            });

        }

        function downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        

        activate();

        function activate() { }
    }
})();
